class BarOpacityHandler {
  constructor(bar) {
    this.bar = bar;
    this.variableName = this.bar.dataset.color;
    this.lks = 0;
    this.tick = false;
    // This scrollhandler thing is necessary to eventually remove the event listner
    this.scrollHandler = this.scrolled.bind(this);

    document.addEventListener('scroll', this.scrollHandler);
  }

  scrolled() {
    this.lks = window.scrollY;

    if (!this.tick) {
      window.requestAnimationFrame(() => {
        this.updateBackground();
        this.tick = false;
      });
      this.tick = false;
    }

    this.tick = true;
  }

  updateBackground() {
    if (this.lks >= 100) {
      this.bar.style.backgroundColor = this.variableName;
      document.removeEventListener('scroll', this.scrollHandler);
    }
  }
}

window.addEventListener('DOMContentLoaded', () => {
  const bar = document.querySelector('#header-bar');

  if (bar && bar.dataset.opac === '1') {
    new BarOpacityHandler(bar);
  }
});
